// Estado de UI LOCAL do módulo — não entra no doc e não é desfazível.

import type { WordsearchDoc } from './doc';
import type { WordsearchAction } from './reducer';

export interface WordsearchUi {
  /** Palavra selecionada no Inspector. */
  selectedRef: string | null;
  /** Arrasto em curso no Canvas: célula onde começou. */
  dragStart: { x: number; y: number } | null;
  /** Cursor do teclado: a célula que recebe as letras digitadas. O clique simples
   *  na grade o posiciona; as setas o movem. `null` = nenhuma célula em edição. */
  cursor: { x: number; y: number } | null;
  /** Contador de refs novos. Prefixo "n" nunca colide com os "w{id}" carregados. */
  nextRef: number;
}

export function initialWordsearchUi(doc: WordsearchDoc): WordsearchUi {
  const maxN = doc.words.reduce((max, w) => {
    const m = /^n(\d+)$/.exec(w.ref);
    return m ? Math.max(max, Number(m[1])) : max;
  }, 0);
  return { selectedRef: null, dragStart: null, cursor: null, nextRef: maxN + 1 };
}

export function newRef(ui: WordsearchUi): string {
  return `n${ui.nextRef}`;
}

/**
 * Chave de coalescing do undo: ações contínuas com a mesma chave viram uma
 * entrada só. Digitar letras na mesma célula ou uma dica inteira = um undo só;
 * colocar e remover palavra são marcos próprios.
 */
export function coalesceKeyFor(action: WordsearchAction): string | null {
  switch (action.type) {
    case 'TYPE_LETTER':
      return `type:${action.x},${action.y}`;
    case 'SET_CLUE':
      return `clue:${action.ref}`;
    case 'SET_TITULO':
      return 'titulo';
    default:
      return null;
  }
}
